import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import {
  BLOCKS,
  Document as RichTextDocument,
} from "@contentful/rich-text-types";
import { Button } from "@components/shared/core/Button";
import { Link } from "@components/shared/core/Link";
import { DEFAULT_404 } from "./DEFAULT_404";
import { Helmet } from "react-helmet-async";

export function NotFound() {
  const item = DEFAULT_404;

  return (
    <>
      <Helmet>
        <title>404</title>
      </Helmet>
      <section className="aspect-video w-full dsk:min-h-full min-h-screen flex flex-col justify-center items-center relative gap-9">
        <img
          src={item.background.url}
          alt=""
          className="absolute inset-0 w-full h-full object-cover brightness-60"
        />
        <div className="z-10 mt-auto">
          <h1 className="text-heading-1 whitespace-pre-wrap text-center">
            {item.title ?? "404"}
          </h1>
        </div>
        <div className="z-10">
          {item.body?.json != null &&
            documentToReactComponents(item.body.json as RichTextDocument, {
              renderNode: {
                [BLOCKS.PARAGRAPH]: (_, children) => (
                  <p className="text-body-regular">{children}</p>
                ),
              },
            })}
        </div>
        <div className="z-10 mt-auto mb-8">
          <Button asChild variant="light-on-blur">
            <Link href="/">{item.ctaText ?? "Back To Home"}</Link>
          </Button>
        </div>
      </section>
    </>
  );
}
